module.exports = __webpack_public_path__ + "img/visa.038a4023.png";